export default __webpack_public_path__ + "static/media/portfolio-7.aa04d7b9.jpg";